import { setLayerFilters } from "./misc";
import { EXPRESSIONS } from "../../layers/variables/expressions";
export function filterPolygonRooms(baseLevelFilter, cuMap) {
    const layerIds = cuMap.cuLayerIds;
    const layerIds_temporary = cuMap.cuLayerIds_temporary;
    // min zoom zum spawnen
    const zoomFilters = [">", ["zoom"], 11];
    const roomFilters = [
        "all",
        ["!", EXPRESSIONS.roomType.hiddenRoom],
        zoomFilters,
    ];
    // filter für die Räume, die aus Glas sind
    const glassRoomFilters = ["all", EXPRESSIONS.roomType.glass, zoomFilters];
    setLayerFilters([
        layerIds.indoorGeoJSONs.outline,
        layerIds_temporary.indoorGeoJSONs.outline,
    ], baseLevelFilter.concat([zoomFilters]), cuMap);
    setLayerFilters([layerIds.indoorGeoJSONs.rooms, layerIds_temporary.indoorGeoJSONs.rooms], baseLevelFilter.concat([roomFilters]), cuMap);
    setLayerFilters([
        layerIds.indoorGeoJSONs.glassRooms,
        layerIds_temporary.indoorGeoJSONs.glassRooms,
    ], baseLevelFilter.concat([glassRoomFilters]), cuMap);
}
/** Karte bouncen lassen beim wechsel der etagen, aber nicht während einer anderen animation */
export function bounceAnimation(prevLevel, level, cuMap) {
    let zoomIn = cuMap.getZoom() + 0.04;
    let zoomOut = cuMap.getZoom() - 0.04;
    if (prevLevel !== level) {
        if (cuMap.isMoving())
            return;
        cuMap.flyTo({
            zoom: prevLevel > level ? zoomIn : zoomOut,
            speed: 0.18,
            curve: 1,
            easing(t) {
                return Math.sin(t);
            },
        });
        cuMap.once("moveend", () => {
            if (cuMap.isMoving())
                return;
            cuMap.flyTo({
                zoom: prevLevel > level ? zoomOut : zoomIn,
                speed: 0.25,
                curve: 1,
                easing(t) {
                    return Math.sin(t);
                },
            });
        });
    }
}
